import { LoadingIndicator, LoadingProps } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

interface LoadingOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  isOpen: boolean;
  /** The size of the loading indicator. @default 'lg' */
  size?: LoadingProps['size'];
  /** The variant of the loading indicator. @default 'page' */
  variant?: LoadingProps['variant'];
  /** Sets the loading overlay to fixed positioning and a left offset for the sidenav. @default false */
  fixed?: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isOpen,
  size = 'lg',
  variant = 'page',
  fixed = false,
  ...props
}) => (
  <div
    className={cn(
      'absolute inset-0 z-5 h-full min-h-[300px] flex-col items-center justify-center overflow-auto bg-white',
      isOpen ? 'flex' : 'hidden',
      {
        'fixed md:left-[56px] lg:left-(--sidenav-width)': fixed,
      },
      props.className,
    )}
    data-testid="LoadingOverlay"
  >
    <LoadingIndicator size={size} variant={variant} />
    {props.children}
  </div>
);

export default LoadingOverlay;
